/**
 * index.js — Entry point custom
 *
 * IMPORTANT : doit être référencé via "main": "index.js" dans package.json
 *
 * Avec RN 0.83.1 (Expo SDK 55), le bug iOS 26 TurboModule est corrigé
 * upstream via la PR a9a976a. MAIS RCTExceptionsManager peut quand même
 * remonter des exceptions JS non-catchées comme fatales → SIGABRT.
 *
 * Solution : installer un global error handler qui catch tout AVANT que
 * RCTExceptionsManager.reportFatal soit appelé.
 */

// ═══ Global error handler — DOIT être installé avant TOUT autre code ═══
// Sans ça, n'importe quelle exception non-catchée dans un useEffect, un
// setTimeout ou une promesse devient fatale via RCTExceptionsManager.
if (typeof ErrorUtils !== 'undefined' && ErrorUtils.setGlobalHandler) {
  const defaultHandler = ErrorUtils.getGlobalHandler && ErrorUtils.getGlobalHandler();
  ErrorUtils.setGlobalHandler((error, isFatal) => {
    try {
      console.warn('[GlobalErrorHandler]', isFatal ? 'FATAL' : 'non-fatal', error?.message || error);
      if (error && error.stack) {
        console.warn('[GlobalErrorHandler] stack:', error.stack);
      }
    } catch (_) {}
    // En production, on ABSORBE même les fatales pour éviter SIGABRT
    // (sinon iOS 26 + TurboModule = crash app entière).
    // En dev, on délègue au handler par défaut pour voir le LogBox rouge.
    if (__DEV__ && defaultHandler) {
      try { defaultHandler(error, isFatal); } catch (_) {}
    }
  });
}

// Catch des promesses non-handled (ex: SecureStore.getItemAsync qui throw)
if (typeof process !== 'undefined' && process.on) {
  try {
    process.on('unhandledRejection', (reason) => {
      console.warn('[UnhandledRejection]', reason?.message || reason);
    });
  } catch (_) {}
}

// ═══ Mount React après installation du handler ═══
import { registerRootComponent } from 'expo';
import App from './App';

registerRootComponent(App);
